import ActionCard from '../ActionCard/ActionCard';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { deviceStatusMapper, statusImages } from '../../Helpers/deviceStatusMap';

const ActionGrid = ({ actions, statusCounts, mapper = deviceStatusMapper }) => {
  return(
    <Grid container spacing={4}>
      {actions.map((status, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
            <Box>
            <ActionCard 
              actionDescription={`${mapper[status]}: ${statusCounts[status]}`}
              image={statusImages[status]}
              status = {status}/>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default ActionGrid;